import { render, staticRenderFns } from "./TheMore.vue?vue&type=template&id=21a6ac8e&scoped=true&"
var script = {}
import style0 from "./TheMore.vue?vue&type=style&index=0&id=21a6ac8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6ac8e",
  null
  
)

export default component.exports